
export class ChangeEvent<T>
{
  private _lastValue:T;
  get lastValue() { return this._lastValue; }
  private _newValue:T;
  get newValue(){ return this._newValue; }

  constructor( lastValue:T, newValue:T )
  {
    this._lastValue = lastValue;
    this._newValue = newValue;
  }

}